import { useCurrentUserContext } from '../providers/current-user-provider'

const useCurrentUser = () => {
  const context = useCurrentUserContext()

  return context.currentUser
}

export default useCurrentUser
